import { STATES } from '../../constants';

export function UnsubscribeConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.UNSUBSCRIBE, {
    url: '/unsubscribe/invite/:token',
    scrollTop: true,
    title: 'Unsubscribe',
    views: {
      '@': {
        template: '<upd-unsubscribe></upd-unsubscribe>',
      },
    },
  });
}
